//------------------------------------------------------------------------
// Main nav toggle
//------------------------------------------------------------------------
"use strict";
import Modal from "./modals";

const nav = document.querySelector("#nav");
if (nav) {
  const navModal = new Modal(nav, {
    modalContentClass: "Nav-wrap"
  });
}
